module.exports = __webpack_public_path__ + "static/media/configura_rnds.da89a211.gif";